export const ProvinceCoA: { [key: string]: string } = {
  "DRN": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Drenthe_wapen.jpg",
  "FLV": "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flevoland_wapen.png",
  "FRI": "https://upload.wikimedia.org/wikipedia/commons/1/12/Wapen_van_Friesland.jpg",
  "GEL": "https://upload.wikimedia.org/wikipedia/commons/0/08/Gelderland_wapen.svg",
  "GRN": "https://upload.wikimedia.org/wikipedia/commons/d/d9/Groningen_provincie_wapen.svg",
  "LIM": "https://upload.wikimedia.org/wikipedia/commons/c/c1/Limburg_NL_wapen.svg",
  "NB":  "https://upload.wikimedia.org/wikipedia/commons/0/05/Noord-Brabant_wapen.svg",
  "NH":  "https://upload.wikimedia.org/wikipedia/commons/4/43/Noord-Holland_wapen.svg",
  "OVR": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Overijssel_wapen.svg",
  "UTR": "https://upload.wikimedia.org/wikipedia/commons/0/02/Utrecht_provincie_wapen.svg",
  "ZLD": "https://upload.wikimedia.org/wikipedia/commons/9/9b/Wapen_van_Zeeland.svg",
  "ZHH": "https://upload.wikimedia.org/wikipedia/commons/8/87/Zuid-holland_wapen.svg"
};